import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {first} from 'rxjs/operators';
import {BsModalRef } from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {DangKyService} from '../../../service/vpp/service-dangky';
import {DangKy} from '../../../models/vpp/dangky';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  templateUrl: './detail.component.html'

})
export class DetailDangKyComponent implements OnInit, AfterViewInit {

  public language = language;
  public id: number=0;
  public itemDangKy: DangKy = new DangKy();
  public onClose: Subject<boolean>;
  constructor( public dangKyService: DangKyService,
               public _bsModalRef: BsModalRef,
               public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  public edit(id: number) {

    this.dangKyService.getById(id).pipe(first())
      .subscribe(x => {
        this.itemDangKy = x;
      });
  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

